import { getLang } from '@shared/i18n';
import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../config';

export default function DeleteAccount() {
  return getLang() === 'en' ? <DeleteAccountEn /> : <DeleteAccountFr />;
}

function DeleteAccountEn() {
  return (
    <div className="container narrow legal" style={{ paddingTop: 40 }}>
      <h1>Delete your FollowMe account</h1>
      <h2>From the app (immediate)</h2>
      <ol>
        <li>
          Open FollowMe and go to <strong>Profile → My account</strong>.
        </li>
        <li>
          Tap <strong>Delete my account</strong>, then confirm twice.
        </li>
      </ol>
      <p>
        If your account is still pending approval, the <strong>Delete my account</strong> button is available directly
        on the waiting screen.
      </p>
      <h2>By e-mail</h2>
      <p>
        If you no longer have access to the app, write to{' '}
        <a href={`mailto:${CONTACT_EMAIL}?subject=Account%20deletion`}>{CONTACT_EMAIL}</a> from your account's e-mail
        address, with the subject “Account deletion”. We delete the account within 30 days at the latest and confirm it
        to you by e-mail.
      </p>
      <h2>What is deleted</h2>
      <ul>
        <li>your account (e-mail, password) and your sessions;</li>
        <li>your profile: display name, first name, last name, car, number plate;</li>
        <li>your event registrations and your shared locations;</li>
        <li>your trip history;</li>
        <li>your messages and photos in the chats;</li>
        <li>your notification tokens.</li>
      </ul>
      <p>
        Deletion is permanent. Events and routes created by an organiser remain available to other members, without any
        mention of their author. No data is kept after deletion, except where required by law. More information:{' '}
        <Link to="/confidentialite">privacy policy</Link>.
      </p>
    </div>
  );
}

function DeleteAccountFr() {
  return (
    <div className="container narrow legal" style={{ paddingTop: 40 }}>
      <h1>Supprimer son compte FollowMe</h1>
      <h2>Depuis l'app (immédiat)</h2>
      <ol>
        <li>
          Ouvrez FollowMe et allez dans <strong>Profil → Mon compte</strong>.
        </li>
        <li>
          Touchez <strong>Supprimer mon compte</strong>, puis confirmez deux fois.
        </li>
      </ol>
      <p>
        Si votre compte est encore en attente de validation, le bouton <strong>Supprimer mon compte</strong> se trouve
        directement sur l'écran d'attente.
      </p>
      <h2>Par e-mail</h2>
      <p>
        Si vous n'avez plus accès à l'app, écrivez à{' '}
        <a href={`mailto:${CONTACT_EMAIL}?subject=Suppression%20de%20compte`}>{CONTACT_EMAIL}</a> depuis l'adresse
        e-mail de votre compte, avec l'objet « Suppression de compte ». Nous supprimons le compte sous 30 jours au plus
        tard et vous le confirmons par e-mail.
      </p>
      <h2>Ce qui est supprimé</h2>
      <ul>
        <li>votre compte (e-mail, mot de passe) et vos sessions ;</li>
        <li>votre profil : nom affiché, prénom, nom, voiture, plaque d'immatriculation ;</li>
        <li>vos inscriptions aux événements et vos positions partagées ;</li>
        <li>votre historique de trajets ;</li>
        <li>vos messages et photos dans les discussions ;</li>
        <li>vos jetons de notification.</li>
      </ul>
      <p>
        La suppression est définitive. Les événements et tracés créés par un organisateur restent disponibles pour les
        autres membres, sans mention de leur auteur. Aucune donnée n'est conservée après la suppression, sauf obligation
        légale. Plus d'informations : <Link to="/confidentialite">politique de confidentialité</Link>.
      </p>
    </div>
  );
}
